import React, { useState } from "react";
import { styled } from '@mui/material/styles';
import Header from "../components/Header";
import Footer from "../components/Footer";
import GlobalStyles from "@mui/material/GlobalStyles";

import {
    CssBaseline,
    Paper,
} from "@mui/material";

const GlobalStyle = () =>
    <GlobalStyles
        styles={(theme) => ({
            'html, body, #root': {
                height: '100%'
            },
            body: {
                background: theme.body.background
            },
            '.MuiCardHeader-action .MuiIconButton-root': {
                padding: '4px',
                width: '28px',
                height: '28px',
            }
        })}
    />;


const Root = styled('div')({
    display: 'flex',
    minHeight: '100vh'
});

const AppContent = styled('div')({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '100%'
});

const MainContent = styled(Paper)(({ theme }) => ({
    flex: 1,
    background: theme.body.background,
    '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        flex: 'none'
    },
    '.MuiPaper-root .MuiPaper-root': {
        boxShadow: 'none'
    },
    padding: `${theme.spacing(1)} ${theme.spacing(5)}`
}));

const DashboardLayout = ({ children, userGuide }) => {

    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    return (
        <Root>
            <CssBaseline />
            <GlobalStyle />
            <AppContent>
                <Header onDrawerToggle={handleDrawerToggle} userGuide={userGuide} />
                <MainContent>
                    {children}
                </MainContent>
                <Footer />
            </AppContent>
        </Root>
    );
}

export default DashboardLayout;